import { render, staticRenderFns } from "./suorite-form.vue?vue&type=template&id=65aa0240&scoped=true&"
import script from "./suorite-form.vue?vue&type=script&lang=ts&"
export * from "./suorite-form.vue?vue&type=script&lang=ts&"
import style0 from "./suorite-form.vue?vue&type=style&index=0&id=65aa0240&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65aa0240",
  null
  
)

export default component.exports